/**
 * HeaderBar component displays the app header with branding, flashcard counter, and sign out button.
 *
 * @param {Object} props - Component props
 * @param {number} props.flashcardCount - Total number of flashcards
 * @param {Function} props.onSignOut - Callback when sign out button is clicked
 * @returns {React.ReactElement} Header bar
 */
export default function HeaderBar({ flashcardCount, onSignOut }) {
  return (
    <header className="header-bar">
      <div className="header-bar__container">
        {/* Brand and title */}
        <div className="header-bar__brand">
          <h1 className="header-bar__title">Szybkie Fiszki</h1>
          <p className="header-bar__subtitle">Twoje fiszki do nauki</p>
        </div>

        {/* Flashcard counter */}
        <div className="header-bar__counter">
          <span className="header-bar__count">{flashcardCount}</span>
          <span className="header-bar__count-label">
            {flashcardCount === 1
              ? 'fiszka'
              : flashcardCount % 10 >= 2 &&
                  flashcardCount % 10 <= 4 &&
                  (flashcardCount % 100 < 10 || flashcardCount % 100 >= 20)
                ? 'fiszki'
                : 'fiszek'}
          </span>
        </div>

        {/* Sign out button */}
        <button
          type="button"
          className="header-bar__sign-out"
          onClick={onSignOut}
          aria-label="Wyloguj się"
        >
          Wyloguj
        </button>
      </div>
    </header>
  )
}
